export const eyeTypeName = {
  EYE_LEFT: "EYE_LEFT",
  EYE_RIGHT : "EYE_RIGHT "
}

export const eyeDistance = {
  All_distance_vision: "All_distance_vision",
  Distance_vision: "Distance_vision",
  Near_vision : "Near_vision"
}

const allDistanceVision = {
  "allDistanceVision": [
    {
      axis: "",
      cylinder: "",
      eyeTypeName: eyeTypeName.EYE_LEFT,
      sphere: "",
      visionType: eyeDistance.All_distance_vision
    },
    {
      axis: "",
      cylinder: "",
      eyeTypeName: eyeTypeName.EYE_RIGHT,
      sphere: "",
      visionType: eyeDistance.All_distance_vision
    }
  ]
  
}
const distanceVision = {
  "distanceVision": [
    {
      axis: "",
      cylinder: "",
      eyeTypeName: eyeTypeName.EYE_LEFT,
      sphere: "",
      visionType: eyeDistance.Distance_vision
    },
    {
      axis: "distance vision",
      cylinder: "",
      eyeTypeName: eyeTypeName.EYE_RIGHT,
      sphere: "",
      visionType: eyeDistance.Distance_vision
    }
  ]
  
}
const nearVision = {
  "nearVision": [
    {
      axis: "near",
      cylinder: "",
      eyeTypeName: eyeTypeName.EYE_LEFT,
      sphere: "",
      visionType: eyeDistance.Near_vision
    },
    {
      axis: "",
      cylinder: "",
      eyeTypeName: eyeTypeName.EYE_RIGHT,
      sphere: "",
      visionType: eyeDistance.Near_vision
    }
  ]
  
}
export const visionRequests = [allDistanceVision, distanceVision, nearVision]